import React from "react"
import PropTypes from "prop-types"
import { Flex, Typography } from "antd"
import { Line } from "react-chartjs-2"
import { useTranslation } from "react-i18next"
import { CHART_COLORS, lineChartOptions } from "../constants"
import EmptyState from "components/common/EmptyState"
import styles from "../style.module.css"

const { Text } = Typography

export default function RevenueTrendWidget({ data, periodLabel }) {
  const { t } = useTranslation()
  // chart_data for line: { labels, series: [{ name, data }] }
  const labels = data?.labels ?? []
  const series = Array.isArray(data?.series) ? data.series : []
  const values = series[0]?.data ?? []
  const total = values.reduce((sum, v) => sum + (v ?? 0), 0)

  const chartData = {
    labels,
    datasets: series.map((s, i) => ({
      label: s.name,
      data: s.data,
      borderColor: i === 0 ? CHART_COLORS.blue : CHART_COLORS.amber,
      backgroundColor: i === 0 ? `${CHART_COLORS.blue}14` : `${CHART_COLORS.amber}14`,
      fill: true,
      tension: 0.4,
      pointBackgroundColor: i === 0 ? CHART_COLORS.blue : CHART_COLORS.amber,
      pointRadius: labels.length > 30 ? 2 : 4,
      pointHoverRadius: 6,
      spanGaps: false
    }))
  }

  return (
    <div className={styles.widgetContent}>
      <Flex justify="space-between" align="center" className={styles.widgetHeader}>
        <Text strong>{t("ai_dashboard.widget_revenue_trend")}</Text>
        <span className={styles.periodTag}>{periodLabel}</span>
      </Flex>
      <Text type="secondary" className={styles.textPeriodInfo}>${total.toLocaleString()} {t("ai_dashboard.during_period")}</Text>
      <div className={styles.chartWrapperMd}>
        {labels.length > 0
          ? <Line data={chartData} options={lineChartOptions} />
          : <div className={styles.widgetEmptyState}><EmptyState title={t("ai_dashboard.no_data")} description=" " /></div>
        }
      </div>
    </div>
  )
}

RevenueTrendWidget.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  periodLabel: PropTypes.string,
}
